var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isHidden
    ? _c("div", { staticClass: "mobile-to-desktop-transition" }, [
        _c(
          "div",
          {
            class: {
              "mobile-to-desktop-transition__shim": true,
              "mobile-to-desktop-transition__shim--closed": _vm.isDrawerClosed
            }
          },
          [
            _c(
              "div",
              {
                class: {
                  "mobile-to-desktop-transition__drawer": true,
                  "mobile-to-desktop-transition__drawer--closed":
                    _vm.isDrawerClosed
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "mobile-to-desktop-transition__content" },
                  [
                    _c("img", {
                      staticClass: "mobile-to-desktop-transition__img",
                      attrs: {
                        src: require("../sprites/art-and-design/mobile-to-desktop.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n          This interactive lesson is a lot better on a computer screen. We'll send you a link to\n          pick up where you left off.\n        "
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.hasClickedEmailCta
                      ? _c(
                          "Button",
                          {
                            staticClass: "btn-email-me-a-link",
                            attrs: { primary: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.emailMeALink($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Email me the lesson link\n        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasClickedEmailCta
                      ? _c(
                          "Button",
                          {
                            staticClass: "btn-email-sent",
                            attrs: { primary: "", disabled: "" }
                          },
                          [
                            _vm._v("\n          Email sent\n          "),
                            _c("CheckIcon", {
                              staticClass: "check-icon",
                              attrs: { color: "#999999" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "Button",
                      {
                        staticClass: "btn-continue-anyway",
                        attrs: { secondary: "" },
                        on: { click: _vm.goToCourseIndex }
                      },
                      [_vm._v("\n          Browse all courses\n        ")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }